define('tdfloor', ['jquery'], function ($) {

    var tdfloor = {
        changeSelect: function changeSelect() {
            var _this = this;

            this.floorSelect = jQuery('.product__select.floor-config-type-option select');
            this.floorSelectTrigger = jQuery('.product__select.wallpaper .sb-wp-inner');

            if (this.floorSelect.length == 0) return;

            var productSample = $('.js_productSample');
            var typSelector = $('.js_typ-selector');
            var showClassName = 'js_show';

            this.floorSelectTrigger.on('click', function (e) {
                var self = $(e.currentTarget);
                var selfIndex = self.data('index');
                var option = _this.floorSelect.find('option:not([value=""])').eq(selfIndex);

                if (option.text().indexOf('Muster') !== -1 || option.text().indexOf('A4 Muster') !== -1) {
                    productSample.addClass(showClassName);
                    typSelector.hide();
                } else {
                    productSample.removeClass(showClassName);
                    typSelector.show();
                }

                _this.floorSelectTrigger.removeClass('checked') && self.addClass('checked') && option.prop('selected', true) &&
                //this.floorSelect.trigger('change') &&
                _this.floorSelect.get(0).simulate('change');
                customEvent(_this.floorSelect.attr('id'), 'change');
            });

            this.floorSelectTrigger.eq(0).click();
        },
        floorCalculator: function floorCalculator() {
            var previousQty = null;
            $('.product__details').on('keyup', '.floor-calc-option', function (e) {
                var lengthOption = $('.floor-calc-length');
                var widthOption = $('.floor-calc-width');
                var qtySelector = $('#qty');
                var qtyMinValue = qtySelector.find('option:first').val();
                var qtyMaxValue = qtySelector.find('option:last').val();

                if (!(lengthOption.length && widthOption.length && packingUnit)) {
                    return;
                }

                var surchargeValue = 0;
                if ($('.surcharge-value-input').val()) {
                    surchargeValue = parseFloatCustom($('.surcharge-value-input').val());
                }
                var qty = qtyMinValue;

                var length = parseFloatCustom(lengthOption.val());
                var width = parseFloatCustom(widthOption.val());
                if (length && width) {
                    var square = length * width * (1 + surchargeValue);
                    if (square) {
                        square = Math.round(square * 100) / 100;
                        qty = Math.ceil(square / packingUnit);
                        if (!qty || qty < qtyMinValue) {
                            qty = qtyMinValue;
                        } else if (qty > qtyMaxValue) {
                            qty = qtyMaxValue;
                        }
                    }
                }
                qtySelector.val(qty);

                if (!previousQty || previousQty != qty) {
                    qtySelector.addClass('calculated');
                    setTimeout(function () {
                        qtySelector.removeClass('calculated');
                    }, 1000);
                }
                previousQty = qty;
            });
        },
        surchargeCheckboxChange: function surchargeCheckboxChange() {
            $('.product__details').on('change', '.surcharge-checker', function () {
                var checkbox = $(this);
                var surchargeValue = $('.surcharge-value-input');
                var squareParam = $('.floor-calc-square').parents('.product__persparam');

                if (!squareParam.length) {
                    return false;
                }

                if (checkbox.prop('checked')) {
                    surchargeValue.val(surchargeValue.attr('data-surcharge-value'));
                    squareParam.addClass('show-surcharge');
                } else {
                    surchargeValue.val(0);
                    squareParam.removeClass('show-surcharge');
                }

                $('.floor-calc-length').keyup(); // hack to start calculation
            });
        },
        init: function init() {
            this.changeSelect();
            this.floorCalculator();
            this.surchargeCheckboxChange();
        }
    };

    return tdfloor;
});

